if (!customElements.get('filazoo-collection-card')) {
  /* Kept in step with the `widths` given to image_tag in
     snippets/filazoo-collection-card.liquid. */
  const IMAGE_WIDTHS = [180, 260, 360, 540, 720, 900];

  /* A swatch only carries its 900w image URL. Every other candidate is that same
     URL with a different `width` parameter, so the srcset is rebuilt here rather
     than spelled out per swatch in the markup, where it cost ~130KB on the
     homepage alone. Returns '' for anything unexpected so the browser simply
     falls back to `src`. */
  const buildSrcset = (url) => {
    if (!url || !/[?&]width=\d+/.test(url)) return '';
    return IMAGE_WIDTHS.map((width) => `${url.replace(/([?&]width=)\d+/, `$1${width}`)} ${width}w`).join(', ');
  };

  customElements.define(
    'filazoo-collection-card',
    class FilazooCollectionCard extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onSwatchInteraction);
        this.addEventListener('pointerover', this.onSwatchInteraction);
        this.addEventListener('focusin', this.onSwatchInteraction);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onSwatchInteraction);
        this.removeEventListener('pointerover', this.onSwatchInteraction);
        this.removeEventListener('focusin', this.onSwatchInteraction);
      }

      onSwatchInteraction = (event) => {
        const swatch = event.target.closest('[data-variant-image]');
        if (!swatch || !this.contains(swatch)) return;

        const image = this.querySelector('.filazoo-collection-card__image--primary');
        if (!image) return;

        this.querySelectorAll('[data-variant-image]').forEach((button) => {
          const selected = button === swatch;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected.toString());
        });

        image.classList.add('is-changing');
        image.src = swatch.dataset.variantImage;
        image.srcset = buildSrcset(swatch.dataset.variantImage);
        image.alt = swatch.dataset.variantAlt;
        image.addEventListener('load', () => image.classList.remove('is-changing'), { once: true });

        if (image.complete) image.classList.remove('is-changing');

        if (swatch.dataset.variantUrl) {
          this.querySelectorAll('[data-collection-card-link]').forEach((link) => {
            link.href = swatch.dataset.variantUrl;
          });
        }
      };
    }
  );
}
